export const LOCALFORAGE_ID = 'holdemstore';
export const TABLES_INDEX = 'TABLES_INDEX';
